import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Select } from 'foundations-components/transitional/components/Select';
import { KEY_PREFIX } from 'marketplace-ui-common/hooks/useSearchParams';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Paths } from '../../constants/paths';
import { useFilterConfig } from '../../filters/hooks/useFilterConfig';
import { INITIAL_POPULAR_COUNT, POPULAR_SERVICE_SLUGS } from '../constants/find-partner-match';
import { useGetPartnerCount } from '../hooks/useGetPartnerCount';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function FindPartnerMatch({
  onClose
}) {
  const [selectedService, setSelectedService] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const partnerCount = useGetPartnerCount(selectedService);
  const {
    PROFILE_CATALOG_SERVICES: serviceFilter
  } = useFilterConfig({
    productTypes: ['SOLUTIONS_PARTNER_PROFILE']
  });
  const serviceOptions = !(serviceFilter !== null && serviceFilter !== void 0 && serviceFilter.options) ? [] : serviceFilter.options.map(option => ({
    text: option.text,
    value: option.value
  }));
  const allPopularServices = !(serviceFilter !== null && serviceFilter !== void 0 && serviceFilter.options) ? [] : POPULAR_SERVICE_SLUGS.map(slug => serviceFilter.options.find(o => o.slug === slug)).filter(option => !!option && option.value !== selectedService);
  const popularServices = showMore ? allPopularServices : allPopularServices.slice(0, INITIAL_POPULAR_COUNT);
  const handleNext = () => {
    if (!selectedService) return;
    const urlParams = new URLSearchParams(location.search);
    urlParams.set(`${KEY_PREFIX}PROFILE_CATALOG_SERVICES`, selectedService);
    history.push({
      pathname: Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS,
      search: `?${urlParams.toString()}`
    });
    onClose();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    width: 700,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: partnerCount > 0 && /*#__PURE__*/_jsx(FormattedMessage, {
        message: partnerCount > 1 ? 'marketplaceStorefront.hero.solutions.findPartnerMatch.matchingPartners.other' : 'marketplaceStorefront.hero.solutions.findPartnerMatch.matchingPartners.one',
        options: {
          partnerCount
        }
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.hero.solutions.findPartnerMatch.service.title"
        })
      }), /*#__PURE__*/_jsx(Select, {
        options: serviceOptions,
        placeholder: unescapedText('marketplaceStorefront.hero.solutions.findPartnerMatch.service.placeholder'),
        onChange: ({
          target: {
            value
          }
        }) => setSelectedService(value),
        value: selectedService !== null && selectedService !== void 0 ? selectedService : undefined
      }), !!popularServices.length && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H4, {
          marginBlockStart: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.hero.solutions.findPartnerMatch.popularServices"
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexWrap: "wrap",
          gap: "200",
          children: [popularServices.map(service => /*#__PURE__*/_jsxs(Button, {
            margin: "0",
            onClick: () => setSelectedService(service.value),
            size: "small",
            use: "tertiary",
            children: ["+ ", service.text]
          }, service.value)), !showMore && allPopularServices.length > INITIAL_POPULAR_COUNT && /*#__PURE__*/_jsx(Button, {
            margin: "0",
            onClick: () => setShowMore(true),
            size: "small",
            use: "transparent",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.hero.solutions.findPartnerMatch.seeMore"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      align: "between",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        size: "medium",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.hero.solutions.findPartnerMatch.closeButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        disabled: !selectedService,
        onClick: handleNext,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.hero.solutions.findPartnerMatch.nextButton"
        })
      })]
    })]
  });
}